import {useRef, useState} from 'react';
import styles from "./Login.module.css"

import {Link, useNavigate} from "react-router-dom"

import { db } from '../../firebase';
import { doc, setDoc } from "firebase/firestore"; 

import { useAuth } from '../../contexts/authContext';

import googleLogo from "./googleLogo.png"
import twitterLogo from "./twitterLogo.png"

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false);

  const {login, currentUser, continueWithGoogle, continueWithTwitter} = useAuth()

  const history = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)

      history("/")
    } catch(e) {
      setError("Failed to log in")
      console.log(e)
    }

    setLoading(false)
  }

  async function handleGoogleSignIn() {
    await continueWithGoogle();
  }

  async function handleTwitterSignIn() {
    await continueWithTwitter();
  }

  return (
    <div className={styles.loginContainer}>
      <h2>Log In</h2>

      {error && <p>{error}</p>}

      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input type="email" id="email" placeholder="name@example.com" ref={emailRef} />

        <label htmlFor="password">Password</label>
        <input type="password" id="password" placeholder="password" ref={passwordRef} />

        <button type="submit" disabled={loading}>Log In</button>
      </form>

      <Link className={styles.forgotPass} to="/forgot-password">Forgot Password?</Link>

      <p>Or</p>

      <button onClick={handleGoogleSignIn} className={`${styles.oauthBtn} ${styles.googleBtn}`}><img src={googleLogo} /> Continue with Google</button>
      <button onClick={handleTwitterSignIn} className={`${styles.oauthBtn} ${styles.twitterBtn}`}><img src={twitterLogo} /> Continue with Twitter</button>

      <p>Not a member? <Link to="/signup">Sign up now</Link></p>
    </div>
  );
}
